import { FC } from "react";
import MegTemplateIconSvg from "../../public/icons/MEG_Validator.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const MegTemplateIcon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><MegTemplateIconSvg/></span>;
